import PayUSecureForm, { PayUSpecificSecureFormProps } from '../PayUSecureForm/PayUSecureForm';

const PayUCvvSecureForm = (props: PayUSpecificSecureFormProps) => (
    <PayUSecureForm formType="cvv" {...props} />
);

export default PayUCvvSecureForm;
